import React, { useEffect } from 'react'

import Header from '../../../components/Arabic/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Arabic/PageTitle/PageTitle'
import Footer from '../../../components/Arabic/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import Subscribe from '../../../components/Arabic/Subscribe/Subscribe'
import CoperateContent from '../../../components/Arabic/CoperateContent/CoperateContent'

export default function Corperate() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <div>
      <Header page={'corperate'} />
      <UnderHeader className={'corperate'} />
      <PageTitle mainTitle={'المؤسسية'} page={'المؤسسية'} />
      <CoperateContent />
      <Subscribe />
      <LogoPartner />
      <Footer />
    </div>
    
  )
}
